import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import REACT_APP from "../../environment";
import { TextField } from "formik-material-ui";
import { Grid } from "@mui/material";
import axios from "axios";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

export default function AddLibraryFile({ getAllFiles }) {
    // eslint-disable-next-line
    const [loading, setLoading] = React.useState(false);
    const [file, setFile] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const validateCompany = Yup.object({ name: Yup.string().required("Name is required") });
    const emptyData = { name: "" };

    const onSubmit = async (values) => {
        const data = new FormData();
        data.append("name", values.name);
        if (values.acceptance_date) data.append("acceptance_date", values.acceptance_date);
        data.append("file", file);
        setLoading(true);
        await axios
            .post(`${REACT_APP.URL}/api/hrp/tts/adm/library-file`, data, {
                headers: { Authorization: sessionStorage.getItem("token"), "client-id": REACT_APP.CLIENTID, "client-secret": REACT_APP.SECRET },
            })
            .then((res) => {
                setLoading(false);
                getAllFiles();
                toast.success("Success!", { autoClose: 2000 });
                handleClose();
                setFile("");
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                toast.error("An error occurred");
            });
    };

    return (
        <div className="addcompany">
            <Button onClick={handleOpen} variant="contained">
                Add library file
            </Button>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{ backdrop: { timeout: 500 } }}
            >
                <Fade in={open}>
                    <Box sx={style} className="addcompanymodal">
                        <Typography id="transition-modal-title" variant="h6" component="h2" className="marginBottom">
                            Enter library file's information
                        </Typography>
                        <Formik
                            initialValues={emptyData}
                            validationSchema={validateCompany}
                            onSubmit={async (values) => {
                                onSubmit(values);
                                return new Promise((res) => setTimeout(res, 500));
                            }}
                        >
                            {({ values, errors }) => (
                                <Form autoComplete="off" className="mt-4">
                                    <Grid container>
                                        <Grid item xs={12} className="marginBottom">
                                            <Field fullWidth label="Name" name="name" component={TextField} autoComplete="off" type="text" />
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={12} className="marginBottom">
                                            <Field
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                label="Acceptance Date"
                                                name="acceptance_date"
                                                component={TextField}
                                                type="date"
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={4}>
                                        <Grid item xs={12} className="marginBottom">
                                            <Button type="submit" variant="contained" disabled={loading}>
                                                Choose File
                                                <input
                                                    disabled={loading}
                                                    id="hide-file-input"
                                                    type="file"
                                                    accept="application/pdf"
                                                    onChange={(e) => setFile(e.target.files[0])}
                                                />
                                            </Button>
                                            <span>&nbsp; &nbsp;{file.name}</span>
                                        </Grid>
                                    </Grid>
                                    <div className="left_right">
                                        <Button onClick={handleClose} variant="contained" sx={{ mt: 3, mb: 2 }} color="error">
                                            Close
                                        </Button>
                                        {loading ? (
                                            <LoadingButton loading variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                Submit
                                            </LoadingButton>
                                        ) : (
                                            <Button type="submit" className="mt-5" variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                Submit
                                            </Button>
                                        )}
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
